import { loop } from '@niaratech/niara-js-commons';
import React, { useMemo } from 'react';
import { NiaraIcon, NiaraIconNameType } from '@niaratech/niara-icons';
import { SelectInt } from '@niaratech/niara-react-form';
import Count from '../Count';
import * as S from './styles';
export type SelectButtonProps = {
  bgColorButton?: string;
  colorTextButton?: string;
  block?: boolean;
  onValue?: (value: number) => void;
  value?: number;
  maxValue: number;
  highlighted?: boolean | any;
  dataTestId?: string;
  hideFieldLabel?: boolean;
  hideButtonIcon?: boolean;
  buttonIcon?: NiaraIconNameType;
  buttonLabel?: string;
  enforceSelectInput?: boolean;
};
const SelectButton: React.FC<SelectButtonProps> = ({
  value,
  maxValue,
  onValue,
  bgColorButton,
  colorTextButton,
  block,
  highlighted,
  dataTestId,
  hideFieldLabel,
  hideButtonIcon,
  buttonIcon = 'sysShoppingAddCart',
  buttonLabel = "Adicionar",
  enforceSelectInput
}) => {
  const filled = value === 0 || value === null;
  const roomOptions: Array<{
    value;
    label;
  }> = useMemo(() => {
    return loop(maxValue + 1, i => ({
      value: i,
      label: i === 0 ? 'Nenhum quarto ' : i > 1 ? `${i} quartos` : `${i} quarto`
    }));
  }, [maxValue]);
  const max = roomOptions.map(i => i.value).length - 1;
  if (enforceSelectInput) {
    return <S.Container>
        <SelectInt disabled={max < 1} min={0} max={max} value={value} setValue={onValue} size="small" />
      </S.Container>;
  }
  if (filled) {
    return <>
        <S.Btn size="small" disableElevation highlighted={highlighted ? 'highlighted' : highlighted} wide={block ? 'wide' : 'normal'} disabled={!(maxValue > 0)} fullWidth onClick={() => onValue(maxValue > 0 ? 1 : maxValue)} data-testid={dataTestId} {...bgColorButton && {
        bgColorButton: bgColorButton
      }} {...colorTextButton && {
        colorTextButton: colorTextButton
      }}>
          {
          // #178842 - Alterar o label do botão para adicionar itens no carrinho para visão simplificada
        }
          <>
            {!hideButtonIcon && buttonIcon && <NiaraIcon icon={buttonIcon} size={16} />}
            {buttonLabel}
          </>
        </S.Btn>
      </>;
  }
  return <S.Container>
      <S.Mobile>
        {!hideFieldLabel && <S.NumberOfRoomsText>nº de Quartos</S.NumberOfRoomsText>}
        <Count name="nome" min={0} max={max} value={value} onChange={onValue} color={'info'} />
      </S.Mobile>

      <S.Desktop>
        <Count name="nome" min={0} max={max} value={value} onChange={onValue} color={'textColor'} />
      </S.Desktop>
    </S.Container>;
};
export default SelectButton;